import styled from "styled-components";

export default styled.div`
display:flex
justify-content:center;
align-items:center;
width:100%;
padding-left:30px;
`;